// Vendor libraries
import { createReducer, on } from '@ngrx/store';
// Actions
import { setFundChartNote } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/note/note.actions';
import { setChartData } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/chart-data/chart-data.actions';
export const note = createReducer('', on(setChartData, (state, { chartData }) => chartData.params.note), on(setFundChartNote, (state, action) => action.note));
